import React from "react";

export const SearchIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0846 13.0994L18 18M15.1667 8.08333C15.1667 11.9953 11.9953 15.1667 8.08333 15.1667C4.17131 15.1667 1 11.9953 1 8.08333C1 4.17131 4.17131 1 8.08333 1C11.9953 1 15.1667 4.17131 15.1667 8.08333Z"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
